export default [
  {
    block_id:1,
    data:{
      text:'',
      buttons:[
      ]
    },
    errorOrEmpty:0
  },
  {
    block_id:17,
    data:{
      text:'',
      buttons:[]
    },
    errorOrEmpty:0
  },
  {
    block_id:6,
    data:{
      url:''
    },
    errorOrEmpty:0
  },
  {
    block_id:15,
    data:{
      url:'',
      text:''
    },
    errorOrEmpty:0
  },
  {
    block_id:16,
    data:{
      url:'',
      text:'',
      subtitle:''
    },
    errorOrEmpty:0
  },
  {
    block_id:8,
    data:{
      for:1000
    },
    errorOrEmpty:1
  },
  {
    block_id:3,
    data:{
      url:''
    },
    errorOrEmpty:0
  },
  {
    block_id:4,
    data:{
      items:[
        {
          url:'',
          header:'',
          subtitle:'',
          imageUrl:'',
          buttons:[

          ]
        }
      ],
    }
  },
  {
    block_id:5,
    data:{
      url:''
    },
    errorOrEmpty:0
  },
  {
    block_id:7,
    data:{
      filter:[],
      blocks:[{
        blocks:[]
      }],
      random:false
    },
    errorOrEmpty:0
  },
  {
    block_id:10,
    data:{
      attributes:[
      ]
    },
    errorOrEmpty:0
  },
  {
    block_id:13,
    data:{
      image:'',
      items:[
        {
          header:'',
          subtitle:'',
          url:'',
          image:'',
          buttons:[

          ]
        }
      ],
      buttons:[

      ]
    },
    errorOrEmpty:0
  },
  {
    block_id:11,
    data:{
      items:[
      ],
    },
    errorOrEmpty:0
  },
  {
    block_id:12,
    data:{
      type:'get',
      url:'',
      user_attribute:[],
      report:false,
      attributeFields:[],
      headers: []
    },
    errorOrEmpty:0
  },
  {
    block_id:14,
    data:{
      from : 100,
      to: 200,
      userAttribute:''
    },
    errorOrEmpty:0
  },
  {
    block_id:18,
    data:{
      cards:[

      ]
    },
    errorOrEmpty:0
  },
  {
    block_id:20,
    data:{
      confirmation_number: '',
      currency: '',
      introMessage: '',
      passengers: [  ],
      details_url: '',
      flight_info: [
      ],
      total: ''
    },
    errorOrEmpty:0
  },
  {
    block_id: 22,
    data: {
      type: '',
      status: '',
      status_color: '',
      passengers: [

      ],
      flight: '',
      airline: '',
      checkin: '',
      gate: '',
      carousel: '',
      sch_arrives_time: '',
      sch_arrives_date: '',
      est_arrives_time: '',
      est_arrives_date: '',
      sch_departs_time: '',
      sch_departs_date: '',
      est_departs_time: '',
      est_departs_date: '',
      travel: {
        originName: '',
        destName: '',
        originAcronym: '',
        destAcronym: '',
      }
    },
    errorOrEmpty: 0
  },
  {
    block_id: 19,
    data:{
      template_type: 'receipt',
      recipient_name: '',
      order_number: '',
      currency: 'USD',
      payment_method: 'Visa 2345',
      timestamp: '1428444852',
      address: {
        street_1: '1 Hacker Way',
        street_2: '',
        city: 'Menlo Park',
        postal_code: '94025',
        state: 'CA',
        country: 'US'
      },
      summary: {
        subtotal: 75,
        shipping_cost: 4.95,
        total_tax: 6.19,
        total_cost: 56.14
      },
      adjustments: [

      ],
      elements: [

      ]
    },
    errorOrEmpty:0
  },
  {
    block_id:21,
    data:{
      area: '',
      imageUrl: '',
      temp: '',
      hiTemp: '',
      lowTemp: ''
    },
    errorOrEmpty:0
  },
  {
    block_id:23,
    data:{
      message:'',
      save_to_attribute:'',
      userAttribute: '',
      stopWord:'',
      errorMsg: ''
    },
    errorOrEmpty:0
  },
  {
    block_id:24,
    data:{
      buttonTitle: '',
      title: '',
      description: '',
      lat: '',
      lon: '',
      imageUrl: ''
    },
    errorOrEmpty:0
  },
  {
    block_id:25,
    data:{
      message:'',
      hasTime: false,
      buttonTitle: '',
      save_to_attribute: '',
      errorMessage: '',
    },
    errorOrEmpty:0
  },
  {
    block_id:26,
    data:{
      queueName: '',
      blocksFinishing: [],
      blocksNotAvailable: [],
      blocksNotAnswering: []
    },
    errorOrEmpty:0
  },
  {
    block_id: 29,
    data: {}
  },
  {
    block_id:27,
    data:{
      to: '',
      cc: '',
      bcc: '',
      subject: '',
      bodyText: '',
      bodyAttributes: [],
      useTemplate: false
    },
    errorOrEmpty:0
  },
  {
    block_id:28,
    data:{
      url: '',
      fileName: ''
    },
    errorOrEmpty:0
  },
  {
    block_id:30,
    data:{
      message:'',
      buttonTitle: '',
      save_to_attribute_time: '',
      save_to_attribute_date: '',
      errorMessage: '',
      extensionTitle: '',
      extensionMessage: '',
      request: {
        type:'get',
        url:'',
        user_attribute:[],
        headers: []
      }
    },
    errorOrEmpty:0
  },
  {
    block_id:32,
    data:{
      buttonTitle: '',
      errorMessage: '',
      extensionTitle: '',
      extensionMessage: '',
      extensionImage: '',
      save_to_attribute_cart: '',
      save_to_attribute_cost: '',
      currentBranch: '',
      branches: [],
      requestGetProducts: {
        type:'get',
        url:'',
        user_attribute:[],
        headers: []
      },
      requestGetOrder: {
        type:'get',
        url:'',
        user_attribute:[],
        headers: []
      },
      requestSubmitOrder: {
        type:'post',
        url:'',
        user_attribute:[],
        headers: []
      }
    },
    errorOrEmpty:0
  },
  {
    block_id:31,
    data:{
      name: '',
      attributes: []
    },
    errorOrEmpty:0
  },
]
